import {useQuery} from "@tanstack/react-query"
import {userServiceV3} from "services"
import {TemplateUserDetails} from "types/templates"

type UserProps = {
    userId?: number
    profileId?: number
    isEnabled?: boolean
}

export const useUserDetailForMessageTemplate = ({userId, profileId, isEnabled = true}: UserProps) => {
    const query = useQuery<TemplateUserDetails>(
        ["user-details-for-message-template", userId, profileId],
        async () => {
            return await userServiceV3.getUserDetailsForChat({userId, profileId})
        },
        {
            enabled: !!(userId || profileId) && isEnabled,
            initialData: {
                userDetails: null,
                profile: null,
                campusDetails: null,
                admissionAdvisor: null,
                finAidAdvisor: null,
                academicAdvisor: null,
                studentLedgerStats: null,
                studentOverallStats: null
            },
            refetchOnMount: false
        }
    )

    return {
        userData: query.data,
        isLoading: query.isFetching
    }
}
